import { Provider } from 'react-redux';
import { store } from 'genopets-utils';
import React from 'react';

export const BattleStore = ({ children }: { children: React.JSX.Element }) => {
  return <Provider store={store}>{children}</Provider>;
};
